import React from "react";
import { Link } from "react-router-dom";

const links = [
  { label: "Home", path: "/" },
  // { label: "Explore Businesses", path: "/explore" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
  { label: "FAQs", path: "/faq" },
];

const legalLinks = [
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Terms & Conditions", path: "/terms-and-conditions" },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-[#eef2f7] bg-white">
      {/* ================= DESKTOP / TABLET ================= */}
      <div className="hidden lg:block">
        {/* Main row */}
        <div className="relative flex h-[68px] w-full items-center px-[28px]">

          {/* LOGO */}
          <Link to="/" className="flex shrink-0 items-center">
            <img
              src="/biznep-mainsite/BizNepLogo.webp"
              alt="BizNep"
              className="h-[48px] w-auto object-contain"
            />
          </Link>

          {/* MAIN NAVIGATION */}
          <nav
            className="
              absolute
              left-1/2
              top-1/2
              flex
              -translate-x-1/2
              -translate-y-1/2
              items-center
              gap-[30px]
            "
          >
            {links.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className="
                  whitespace-nowrap
                  text-[12px]
                  font-medium
                  leading-none
                  text-[#355b86]
                  transition-colors
                  hover:text-[#0b4ea2]
                "
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* ================= SOCIAL ICONS ================= */}
          <div className="ml-auto flex shrink-0 items-center gap-[16px]">

            {/* FACEBOOK */}
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="
                flex
                h-[28px]
                w-[28px]
                items-center
                justify-center
                text-[#355b86]
                transition-colors
                hover:text-[#0758b5]
              "
            >
              <svg
                viewBox="0 0 32 32"
                className="h-[25px] w-[25px]"
                aria-hidden="true"
              >
                <circle
                  cx="16"
                  cy="16"
                  r="15"
                  fill="currentColor"
                />

                <path
                  d="M18.05 25.2v-7.85h2.63l.4-3.05h-3.03v-1.95c0-.88.24-1.48 1.51-1.48h1.61V8.14c-.28-.04-1.24-.12-2.36-.12-2.34 0-3.94 1.43-3.94 4.06v2.22h-2.64v3.05h2.64v7.85h3.18Z"
                  fill="white"
                />
              </svg>
            </a>

            {/* INSTAGRAM */}
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="
                flex
                h-[28px]
                w-[28px]
                items-center
                justify-center
                text-[#355b86]
                transition-colors
                hover:text-[#0758b5]
              "
            >
              <svg
                viewBox="0 0 24 24"
                className="h-[25px] w-[25px]"
                fill="none"
                aria-hidden="true"
              >
                <rect
                  x="3.2"
                  y="3.2"
                  width="17.6"
                  height="17.6"
                  rx="5"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />

                <circle
                  cx="12"
                  cy="12"
                  r="4.1"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />

                <circle
                  cx="17.6"
                  cy="6.5"
                  r="1.15"
                  fill="currentColor"
                />
              </svg>
            </a>

            {/* YOUTUBE */}
            <a
              href="https://www.youtube.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="
                flex
                h-[28px]
                w-[32px]
                items-center
                justify-center
                text-[#355b86]
                transition-colors
                hover:text-[#0758b5]
              "
            >
              <svg
                viewBox="0 0 24 24"
                className="h-[23px] w-[29px]"
                aria-hidden="true"
              >
                <path
                  d="M22.1 7.2a2.98 2.98 0 0 0-2.1-2.1C18.15 4.5 12 4.5 12 4.5s-6.15 0-8 .6a2.98 2.98 0 0 0-2.1 2.1C1.3 9.05 1.3 12 1.3 12s0 2.95.6 4.8a2.98 2.98 0 0 0 2.1 2.1c1.85.6 8 .6 8 .6s6.15 0 8-.6a2.98 2.98 0 0 0 2.1-2.1c.6-1.85.6-4.8.6-4.8s0-2.95-.6-4.8Z"
                  fill="currentColor"
                />

                <path
                  d="M10 15.5v-7l6 3.5-6 3.5Z"
                  fill="white"
                />
              </svg>
            </a>

          </div>
        </div>

        {/* LEGAL + COPYRIGHT */}
        <div className="flex h-[35px] items-center justify-center gap-4">
          <p className="text-[10px] font-medium leading-none text-[#657b98]">
            © 2025 BizNep. All rights reserved.
          </p>

          <span className="text-[10px] text-[#c4ccd6]">
            |
          </span>

          {legalLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className="
                text-[10px]
                font-medium
                leading-none
                text-[#657b98]
                transition-colors
                hover:text-[#0b4ea2]
              "
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="flex flex-col items-center px-5 py-7 lg:hidden">

        {/* LOGO */}
        <Link to="/" className="flex items-center">
          <img
            src="/biznep-mainsite/BizNepLogo.webp"
            alt="BizNep"
            className="h-[55px] w-auto object-contain"
          />
        </Link>

        {/* MAIN NAVIGATION */}
        <nav className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3">
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className="
                whitespace-nowrap
                text-[13px]
                font-medium
                text-[#355b86]
                transition-colors
                hover:text-[#0b4ea2]
              "
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* LEGAL LINKS */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          {legalLinks.map((link, index) => (
            <React.Fragment key={link.label}>
              {index > 0 && (
                <span className="text-[11px] text-[#c4ccd6]">
                  |
                </span>
              )}

              <Link
                to={link.path}
                className="
                  text-[12px]
                  font-medium
                  text-[#657b98]
                  transition-colors
                  hover:text-[#0b4ea2]
                "
              >
                {link.label}
              </Link>
            </React.Fragment>
          ))}
        </div>

        {/* ================= MOBILE SOCIAL ================= */}
        <div className="mt-5 flex items-center gap-4">

          {/* FACEBOOK */}
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="
              flex
              h-[30px]
              w-[30px]
              items-center
              justify-center
              text-[#355b86]
              transition-colors
              hover:text-[#0758b5]
            "
          >
            <svg
              viewBox="0 0 32 32"
              className="h-[26px] w-[26px]"
              aria-hidden="true"
            >
              <circle
                cx="16"
                cy="16"
                r="15"
                fill="currentColor"
              />

              <path
                d="M18.05 25.2v-7.85h2.63l.4-3.05h-3.03v-1.95c0-.88.24-1.48 1.51-1.48h1.61V8.14c-.28-.04-1.24-.12-2.36-.12-2.34 0-3.94 1.43-3.94 4.06v2.22h-2.64v3.05h2.64v7.85h3.18Z"
                fill="white"
              />
            </svg>
          </a>

          {/* INSTAGRAM */}
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="
              flex
              h-[30px]
              w-[30px]
              items-center
              justify-center
              text-[#355b86]
              transition-colors
              hover:text-[#0758b5]
            "
          >
            <svg
              viewBox="0 0 24 24"
              className="h-[26px] w-[26px]"
              fill="none"
              aria-hidden="true"
            >
              <rect
                x="3.2"
                y="3.2"
                width="17.6"
                height="17.6"
                rx="5"
                stroke="currentColor"
                strokeWidth="1.8"
              />

              <circle
                cx="12"
                cy="12"
                r="4.1"
                stroke="currentColor"
                strokeWidth="1.8"
              />

              <circle
                cx="17.6"
                cy="6.5"
                r="1.15"
                fill="currentColor"
              />
            </svg>
          </a>

          {/* YOUTUBE */}
          <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="
              flex
              h-[30px]
              w-[32px]
              items-center
              justify-center
              text-[#355b86]
              transition-colors
              hover:text-[#0758b5]
            "
          >
            <svg
              viewBox="0 0 24 24"
              className="h-[24px] w-[30px]"
              aria-hidden="true"
            >
              <path
                d="M22.1 7.2a2.98 2.98 0 0 0-2.1-2.1C18.15 4.5 12 4.5 12 4.5s-6.15 0-8 .6a2.98 2.98 0 0 0-2.1 2.1C1.3 9.05 1.3 12 1.3 12s0 2.95.6 4.8a2.98 2.98 0 0 0 2.1 2.1c1.85.6 8 .6 8 .6s6.15 0 8-.6a2.98 2.98 0 0 0 2.1-2.1c.6-1.85.6-4.8.6-4.8s0-2.95-.6-4.8Z"
                fill="currentColor"
              />

              <path
                d="M10 15.5v-7l6 3.5-6 3.5Z"
                fill="white"
              />
            </svg>
          </a>

        </div>

        {/* COPYRIGHT */}
        <p className="mt-5 text-center text-[10px] font-medium text-[#657b98]">
          © 2025 BizNep. All rights reserved.
        </p>

      </div>
    </footer>
  );
}